import { Dialog } from '@material-ui/core';
import { FormLabel } from '@material-ui/core';
import { Checkbox } from '@material-ui/core';
import { FormGroup } from '@material-ui/core';
import { Paper } from '@material-ui/core';
import React from 'react';
import 'react-quill/dist/quill.bubble.css'
import './lecture.css'

const singlequestionstyle = {
    margin:'5px'
  }


export class SingleTestView extends React.Component {

    render () {
        const {start,end,questions,submitted,passed,points,maxpoints} = this.props
    return (
        <Dialog open={start} onClose={e => this.props.onclose(false)}>
            <Paper>

            {questions && questions.map((q,i) => 
            <Paper key={i} className="ql-bubble" style={singlequestionstyle}>
            {q.text && <div className="question ql-editor" dangerouslySetInnerHTML={{__html: q.text}}></div>}
            <FormGroup>
                {q.answers && q.answers.map((a,j) =>
                  <div>
                    {a.text &&
                      <FormLabel className="answer" 
                        style={{backgroundColor: (a.checked && a.correct) ? '#00800045': (( a.checked || a.correct) ? '#ff000021' : 'transparent' ) }}>
                            <Checkbox diabled checked={a.checked}/>
                            <div className="answertext" dangerouslySetInnerHTML={{__html: a.text}}></div>
                      </FormLabel> }
                  </div>

                )}
                </FormGroup>
          </Paper>
            )}
            </Paper>
        </Dialog>

    )
    }

    

}